import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'ecg-custom-dialog',
    standalone: true,
    imports: [TranslateModule, MatDialogModule, MatButtonModule],
    templateUrl: './custom-dialog.component.html',
    styleUrl: './custom-dialog.component.scss',
})
export class CustomDialogComponent {
    data = inject(MAT_DIALOG_DATA);
}
